module.exports = __webpack_public_path__ + "media/speech-bubbles/square-speech-bubble--foot-left--red--desktop-787f4a00.svg";